var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DocsShow',{attrs:{"block":_vm.block,"padding":false}},[_c('PrismComponent',{attrs:{"language":_vm.language}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }